import React from 'react'

import { GenericError } from '@sketch/components'

import { PublicationQueryPreferencesFragment } from '@sketch/gql-types'

import PublicationSlider, {
  PublicationSliderPlaceholder,
} from '../PublicationSlider'

import { useGetCommunityPublications } from '../../hooks/useGetCommunityPublications'

interface CommunityPublicationSliderProps {
  analyticsId: string
  preferences: PublicationQueryPreferencesFragment | null
}

const CommunityPublicationSlider = (props: CommunityPublicationSliderProps) => {
  const { preferences, analyticsId } = props

  const { data, loading, error } = useGetCommunityPublications({
    preferences,
  })

  if (loading) {
    return <PublicationSliderPlaceholder />
  }

  if (error || !data) {
    return <GenericError />
  }

  const publications = data.publications
  const items = publications.entries || []

  return <PublicationSlider analyticsId={analyticsId} items={items} />
}

export default CommunityPublicationSlider
